<div class="row w-100 mx-0">
    
    <div class="card mb-3" *ngFor="let item of items">
                    
        <div class="row g-0">
            <div *ngIf="item.image" class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 col-xxl-2">
                <div class="d-flex flex-row justify-content-center align-items-center h-100">
                    <img [src]="item.image.path" [ngClass]="item.image.customClass" class="img-fluid mx-auto pt-2">
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 col-xxl-10">
                <div class="card-body">
                    <span class="card-title fs-5 fw-bold" [innerHTML]="item.title"></span>
                    <p class="card-text"               [innerHTML]="item.text"></p>
                    <p *ngIf="item.button.text != null" class="card-text">
                        <a mat-raised-button class="custom-card-list-item-button" [innerHTML]="item.button.text" [href]="item.button.link"></a>
                    </p>
                </div>
            </div>
        </div>

    </div>
    
</div>
